import { createFileRoute, Outlet } from "@tanstack/react-router";

import { ContentHubSectionTabs } from "src/components/ContentHubSectionTabs";

export const Route = createFileRoute("/_auth/_coach/content-hub/$contentHubId")(
  {
    component: RouteComponent,
    ssr: true,
  },
);

function RouteComponent() {
  const params = Route.useParams();

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="shrink-0 px-2 pt-2">
        <ContentHubSectionTabs contentHubId={params.contentHubId} />
      </div>
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
